import React, { useState, useEffect } from 'react';
import { Card, Typography, Spin, Alert } from 'antd';
import { useParams } from 'react-router-dom';
import { menuAPI } from '../services/api';

const { Title } = Typography;

const FileViewer = () => {
  const { menuId } = useParams();
  const [fileContent, setFileContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const fetchFileContent = async () => {
      try {
        setLoading(true);
        const response = await menuAPI.readMenuFile(menuId);
        const data = response.data || response;
        setFileContent(data.content || '');
      } catch (err) {
        console.error('读取文件失败:', err);
        setError('无法读取文件内容');
      } finally {
        setLoading(false);
      }
    };

    if (menuId) {
      fetchFileContent();
    }
  }, [menuId]);

  if (loading) {
    return (
      <div style={{ padding: isMobile ? '12px' : '24px', textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: isMobile ? '12px' : '24px' }}>
        <Alert message="错误" description={error} type="error" showIcon />
      </div>
    );
  }

  return (
    <div style={{
      padding: isMobile ? '12px' : '24px',
      background: '#0d1117',
      color: '#e6edf3',
      minHeight: 'calc(100vh - 64px)'
    }}>
      <div
        dangerouslySetInnerHTML={{ __html: fileContent }}
        style={{
          minHeight: 'calc(100vh - 120px)',
          background: '#0d1117',
          padding: isMobile ? '8px' : '16px',
          overflow: 'auto',
          borderRadius: '8px'
        }}
      />
    </div>
  );
};

export default FileViewer;
